'use client';

import { ComingSoonSync } from '@/components/common/ComingSoonSync';

interface Props {
  children: React.ReactNode;
}

export default function ClientProvider({ children }: Props) {
  return (
    <>
      <ComingSoonSync />
      {children}
    </>
  );
}
